import { getResponseType } from '../../../shared/internal/HTTP/utils/index.js';
import { Headers as HttpApiHeaders } from '../../../shared/internal/HTTPRequestConfig/Headers.js';
export class Response {
    requestMethod;
    requestHeaders;
    requestBody;
    responseStatusCode;
    responseHeaders;
    responseType;
    response;
    parsedBody;
    constructor(params) {
        const { rawHeaders, reqConfig, response, responseType } = params;
        this.requestBody = '';
        this.requestHeaders = reqConfig.headers;
        this.requestMethod = reqConfig.method;
        this.responseHeaders = new HttpApiHeaders((typeof rawHeaders === 'string' ? parseResponseHeaders(rawHeaders) : Array.from(rawHeaders.entries())) || []);
        this.response = response;
        this.responseStatusCode = params.statusCode;
        this.responseType = responseType;
    }
    get responseBody() {
        return this.parsedBody;
    }
    async compileBody() {
        const responseType = this.responseType || getResponseType(this.responseHeaders.get('content-type'));
        switch (responseType) {
            case 'json':
                this.parsedBody = (await this.response.json());
                break;
            case 'binary':
                this.parsedBody = (await this.response.arrayBuffer());
                break;
            default:
                this.parsedBody = (await this.response.text());
        }
    }
    complete() {
        return {
            requestURI: {},
            requestMethod: this.requestMethod,
            requestHeaders: this.requestHeaders.toArray(),
            requestBody: this.requestBody,
            responseStatusCode: this.responseStatusCode,
            responseHeaders: this.responseHeaders.toArray(),
            responseBody: this.parsedBody,
        };
    }
}
const withoutEmpty = (header) => header.trim().length > 0;
const nameWithValue = (header) => {
    const index = header.indexOf(':');
    return [header.slice(0, index).trim().toLowerCase(), header.slice(index + 1).trim()];
};
function parseResponseHeaders(str) {
    return str.split('\r\n').filter(withoutEmpty).map(nameWithValue);
}
//# sourceMappingURL=Response.js.map